import styled from "styled-components";
import { spacingL, spacingXXL } from "@RooUI";

export const AddressContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${spacingXXL};
  width: 100%;
  input {
    width: 100%;
  }
`;

export const AddressStateZipContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: ${spacingL};
  width: 100%;
  div {
    width: 100%;
  }
`;
